import React from 'react';
import './BeforeGoToKorea.css';
import mockup1 from '../assets/images/mockup-image1.webp';
import mockup2 from '../assets/images/mockup-image2.webp';
import flagIcon from '../assets/images/flag-round.webp';
import ScrollReveal from '../components/ScrollReveal';

export default function BeforeGoToKorea() {
  return (
    <div className="bgk-page" lang="si">
      {/* Hero Header */}
      <ScrollReveal>
        <div className="bgk-hero">
          <div className="bgk-hero-content">
            <h1 className="bgk-hero-title">කොරියාවට යාමට පෙර</h1>
            <div className="bgk-hero-line"></div>
          </div>
          <div className="bgk-hero-graphic">
            {/* Floral graphic placeholder */}
            <div className="floral-graphic"></div>
          </div>
        </div>
      </ScrollReveal>

      <div className="bgk-container">
        {/* Airplane Icon Card */}
        <div className="bgk-airplane-box">
          <div className="airplane-icon">✈</div>
        </div>

        <p className="bgk-intro-text">
          නූතන ශ්‍රී ලාංකික තරුණ පරපුරගේ සිත් සතන්වල “සිහින දේශය” යන විරුදාවලියෙන් කිඳා බැස ඇති කොරියානු රාජ්‍යයේ රැකියා අවස්ථාව උදා කර ගැනීමට නම් මූලික සුදුසුකම් සමූහයක් සපුරාලීමට අවශ්‍ය බව පෙන්වා දිය යුතු බව අපගේ ප්‍රධාන අරමුණයි.
        </p>

        {/* Staggered Rule Boxes */}
        <div className="bgk-rules-staggered">
          <ScrollReveal><div className="rule-box row-reverse">
            <div className="rule-text">
              <span className="bullet-star">✸</span> පළමු මූලිකම සුදුසුකම වනුයේ කොරියානු රැකියා අපේක්ෂකයෙකුගේ වයසයි. ඒ අනුව අදාළ වර්ෂයේ කොරියානු භාෂා ප්‍රවීණතා පරීක්ෂණය පවත්වනු ලබන දිනට වයස අවු. 18ත් ~ අවු. 39ත් අතර විය යුතුය.
            </div>
            <div className="rule-flag"><img src={flagIcon} alt="Korean flag" className="rule-flag-img" /></div>
          </div></ScrollReveal>

          <ScrollReveal><div className="rule-box">
            <div className="rule-flag"><img src={flagIcon} alt="Korean flag" className="rule-flag-img" /></div>
            <div className="rule-text">
              <span className="bullet-star">✸</span> එමෙන් ම අයදුම්කරුවන් සිරගතවීමක් හෝ නීතියෙන් වරදකරු වී බරපතල දඬුවමකට ලක් නොවූ අයෙකු විය යුතුය.
            </div>
          </div></ScrollReveal>

          <ScrollReveal><div className="rule-box row-reverse">
            <div className="rule-text">
              <span className="bullet-star">✸</span> තවද , අයදුම්කරුවන් කොරියානු ජනරජයෙන් පිටුවහල් කිරීමේ හෝ පිටත් වීමේ නියෝග වාර්තාවක් නොමැති අයෙකු විය යුතු අතර කොරියාව තුළ නීතිවිරෝධී ලෙස එක් දිනක් හෝ නොසිටි අයෙකු විය යුතුය.
            </div>
            <div className="rule-flag"><img src={flagIcon} alt="Korean flag" className="rule-flag-img" /></div>
          </div></ScrollReveal>

          <ScrollReveal><div className="rule-box">
            <div className="rule-flag"><img src={flagIcon} alt="Korean flag" className="rule-flag-img" /></div>
            <div className="rule-text">
              <span className="bullet-star">✸</span> එපමණක් ද නොව අයදුම්කරුවන් ශ්‍රී ලංකාවෙන් පිටත් වීමේ තහනමකට ලක් නොවූ අයෙකු විය යුතුය.
            </div>
          </div></ScrollReveal>
        </div>

        {/* Exam Registration Blue Card */}
        <ScrollReveal>
          <div className="bgk-exam-card">
            <p className="exam-intro">
              විභාග ප්‍රවේශ පත්‍ර නිකුත් කිරීමේ දින ශ්‍රව්‍ය දෘශ්‍ය මෙන් ම මුද්‍රිත මාධ්‍යවලින් ද, විදේශ සේවා නියුක්ති කාර්යාංශ වෙබ් අඩවියේ ද පෙර දැනුම් දීමක් සිදු කරන අතර අදාළ වර්ෂයට කොරියාවෙන් එවනු ලබන කෝටා එකට සරිලන පරිදි විභාග ප්‍රවේශ පත්‍ර කොරියාවෙන් එවනු ලබයි. ශ්‍රී ලංකාවේ විවිධ ප්‍රදේශවලින් තෝරා ගත් මධ්‍යස්ථානවල එම විභාග ප්‍රවේශ පත්‍ර නිකුත් කරනු ලැබේ.
            </p>
            <div className="exam-steps-title">විභාග ප්‍රවේශ පත්‍රය ලබා ගැනීමට යන ඔබ පහත කරුණු සම්පූර්ණ කළ යුතු වේ.</div>
            <div className="steps-list">
              <div className="step-item">
                <span className="step-num">1</span>
                <p>ජාතික හැඳුනුම් පත හෝ වලංගු රියදුරු බලපත්‍රය සහ ලෝකයේ සියලු රටවලට යා හැකි පරිදි වලංගු වූ ( All Countries )විදේශ ගමන් බලපත්‍රයක් තිබිය යුතු අතර එය ඉදිරියට වසර දෙකක කාලයක් වලංගු විය යුතුය. ✸ එමෙන් ම එම විදේශ ගමන් බලපත්‍රයේ ඡායාරූපය දැක්වෙන පිටුවේ 80% ප්‍රමාණයේ ඡායා පිටපත් 2ක් වත් (Photo Copy) තිබීම ද අනිවාර්ය වේ.(අයදුම් පත්‍රයේ ඇලවීම සඳහා)</p>
              </div>
              <div className="step-item">
                <span className="step-num">2</span>
                <p>විදේශ ගමන් බලපත්‍රය සඳහා අවශ්‍ය වන ප්‍රමාණයේ සුදු පසුබිමේ වර්ණ ඡායාරූප අවම වශයෙන් 2ක් තිබිය යුතුය.(සෙ.මී.3.5 × 4.5 )එම ඡායාරූප විභාග ප්‍රවේශ පත්‍ර ලබා ගන්නා දිනට ආසන්නයේ දී එනම් අනිවාර්යයෙන් මාස 3ක් ඇතුළත ලබා ගත් ඒවා විය යුතුය.</p>
              </div>
              <div className="step-item">
                <span className="step-num">3</span>
                <p>විභාග ප්‍රවේශ පත්‍ර ගාස්තු වශයෙන් ඇ. ඩොලර් 24කට සමාන මුදලක් අයදුම් කරන දිනට අදාළ විනිමය අනුපාතිකයට අනුව දේශීය මුදලින් ගෙවිය යුතුය.</p>
              </div>
              <div className="step-item">
                <span className="step-num">4</span>
                <p>විභාග ප්‍රවේශපත්ර නිකුත් කරන සෑම මධ්‍යස්ථානයක් ම කොරියානු මානව සම්පත් සංවර්ධන අධිකාරියේ සහ ශ්‍රී ලංකා විදේශ සේවා නියුක්ති කාර්යාංශයේ පුර්ණ අධීක්ෂණය යටතේ සිදුකරනු ලබන අතර සියළු අපේක්ෂකයන් සඳහා විභාග ප්‍රවේශ පත්‍රය ලබාගැනීමට අවශ්‍ය අයදුම් පත්‍රය පුරවන ආකාරය එහි නිලධාරී මහත්ම මහත්මීන් විසින් ඔබව දැනුවත් කරනු ලැබේ.</p>
              </div>
              <div className="step-item">
                <span className="step-num">5</span>
                <p>එහිදී පළමු ව විදේශ ගමන් බලපත්‍රය සහ ඡායාරූප පරීක්ෂා කිරීමෙන් පසු වර්ණ අන්ධතා පරීක්ෂණයකට(Color Blind Test) යොමු කරනු ලැබේ. මෙහි දී එම පරීක්ෂණය අසමත් වුවහොත් ඔබට විභාග ප්‍රවේශ පත්‍රය ලබා ගත නොහැකි වනු ඇත.</p>
              </div>
            </div>
          </div>
        </ScrollReveal>

        {/* Mockups */}
        <div className="bgk-mockups">
          <img src={mockup2} alt="Mockup 1" className="bgk-mockup-img" />
          <img src={mockup1} alt="Mockup 2" className="bgk-mockup-img central" />
          <img src={mockup2} alt="Mockup 3" className="bgk-mockup-img" />
        </div>

        {/* Requirement Lists */}
        <ScrollReveal>
          <div className="bgk-requirements">
            <ul className="req-list">
              <li><span className="req-dot"></span> විදේශ ගමන් බලපත්‍ර ප්‍රමාණයේ සුදු පසුබිමේ වර්ණ ඡායාරූප 05ක් (විභාග ප්‍රවේශපත්රය ලබා ගැනීමේදී ඉදිරිපත් කළ ඡායාරූප ම විය යුතුය.)</li>
              <li><span className="req-dot"></span> විවාහක නම් විවාහ සහතිකය සහ එහි පිටපතක් (ග්‍රාම නිලධාරියා විසින් සහතික කරන ලද)</li>
              <li><span className="req-dot"></span> පුහුණු ගාස්තු සහ වීසා ගාස්තු (මේවායේ නියමිත ගණන් අපගේ app එක හරහා ඔබව දැනුවත් කරනු ඇත.)</li>
              <li><span className="req-dot"></span> ඉන් පසුව ඔබ වෛද්‍ය පරීක්ෂණය සඳහා සහ පොලිස් නිෂ්කාශන වාර්තාවක් ලබා ගැනීම සඳහා යොමු කරන අතර ඒ සඳහා අවශ්‍ය වන සියළු ලේඛන කාර්යාංශය මගින් ලබා දෙනු ඇත.</li>
            </ul>

            <div className="req-highlight-box">
              සේවා ගිවිසුම අත්සන් කළ පසු ඔබ හට කාර්යාංශය මඟින් දින 10ක නේවාසික පෙර විගමනික පුහුණුවකට යොමු කරනු ලැබේ. ඒ සඳහා අවශ්‍ය වන සියළු තොරතුරු ද අපගේ මෙම app එක මඟින් ඔබ ව දැනුවත් කරනු ලැබේ.
            </div>

            <p className="req-sub-title">✸ පුහුණුවට යාමට පෙර කාර්යාංශය විසින් ඔබේ නමින් පෞද්ගලික ලිපිගොනුවක් විවෘත කරන අතර ඔබ කොරියාවට යාමට පෙර එම ලිපිගොනුවේ ඇති පහත සඳහන් සියළු ලේඛන සම්පූර්ණ විය යුතුය.</p>
            
            <ul className="numbered-req-list">
              <li><span>1)</span> කාර්යාංශ ලියාපදිංචි ගාස්තුව</li>
              <li><span>2)</span> ඇපබැඳුම්කරය</li>
              <li><span>3)</span> ග්‍රාමසේවා සහතිකය.</li>
              <li><span>4)</span> ඇපකරුවන් ලෙස පෙනී සිටින අයගේ වැටුප් වාර්තා සහ සේවා සහතික.</li>
              <li><span>5)</span> විවාහක කාන්තාවක් නම් පවුල් පසුබිම් වාර්තාව</li>
              <li><span>6)</span> බඳවා ගැනීමේ ගාස්තුව.</li>
              <li><span>7)</span> වෛද්‍ය පරීක්ෂණ වාර්තාව.</li>
              <li><span>8)</span> පොලිස් නිෂ්කාශන වාර්තාව.</li>
            </ul>

            <div className="req-final-box">
              මෙම සියළු කරුණු සම්පූර්ණ වූ පසු ඔබ කොරියාවට යාම සඳහා නියම සුදුස්සෙකු වන අතර කාර්යාංශය මඟින් අවසාන දේශනයක් පවත්වනු ලැබේ. එහිදී කොරියාවට යාමේදී රැගෙන යායුතු දෑ සහ පිළිපැදිය යුතු කරුණු පිළිබඳ ව පුර්ණ දැනුවත් කිරීමක් සිදු කරනු ලබයි.
            </div>

            <p className="req-sub-title">6) ඉහත පරීක්ෂණය සමත් වූ පසු එම එක් එක් මධ්‍යස්ථානවලට පැමිණ සිටින බැංකු නියෝජිතයන් වෙත ගොස් විභාග ප්‍රවේශ පත්‍ර ගාස්තු ගෙවා ලබාගත් රිසිට් පත ද රැගෙන අයදුම් පත්‍රය පිරවීම සඳහා යොමු විය යුතුය.</p>
            <p className="req-sub-title">7) අයදුම් පත්‍ර පිරවීමේ දී නිෂ්පාදන , ධීවර , ඉදිකිරීම් යන අංශ අතරින් එකක් තෝරා ගත යුතු අතර ඔබ තෝරා ගන්නා විෂය අනුව ලැබෙන ප්‍රශ්න පත්‍රය හා ලකුණු මට්ටම් වෙනස් වනු ඇත.</p>
            <p className="req-sub-title">8) විදේශ සේවා නියුක්ති කාර්යාංශ නිලධාරීන්ගේ උපදෙස්වලට අනුව අයදුම් පත්‍රය පිරවූ පසු එහි එක් කොටසක් ඔවුන් ළඟ තබා ගෙන එක් කොටසක් ඔබට ලබා දෙනු ඇත. වැදගත් කරුණ නම් එම කොටස ඔබ කොරියාවට යන තුරු ම සුරක්ෂිත ව ළඟ තබා ගත යුතු වීමයි.</p>
            <p className="req-sub-title">9) මේ සියලු කරුණු සම්පූර්ණ කළ ද ඔබ මනා සෞඛ්‍ය මට්ටමක් නොමැති ශරීරයේ යම් කොටස් සැත්කම් මඟින් ඉවත් කිරීමක්(ඇඟිලි වැනි කොටස්) හෝ උපතින් අංගවිකල හෝ ශරීර අභ්‍යන්තරයේ ලෝහ යොදා සැත්කම් කර ඇත්නම් ඔබට මේ වටිනා අවස්ථාව අහිමි වන බව කණගාටුවෙන් වුවත් කිව යුතුය.</p>

            <div className="req-final-call">
              ඉහත සුදුසුකම් සම්පූර්ණ වූ ඔබ කොරියානු භාෂා ප්‍රවීණතා පරීක්ෂණය සඳහා සුදුසුකම් ලබන අතර විභාගය සඳහා ඔබ අතට ලැබුණු විභාග ප්‍රවේශ පත්‍ර කොටසේ විභාග අංකයක් සඳහන් කර ඇත. එම අංකයට නියමිත දිනයට මාර්ගගත ක්‍රමයට (Online) විභාගයට පෙනී සිටිය යුතුය.
            </div>

            <ul className="extra-req-list">
              <li>✸ එම විභාගයට පෙනී සිටීම් සඳහා විදේශ ගමන් බලපත්‍රය හා ඔබ ලබා ගත් විභාග ප්‍රවේශ පත්‍රය ද රැගෙන යාම අනිවාර්ය වේ.</li>
              <li>✸ කොරියානු භාෂා ප්‍රවීණතා පරීක්ෂණය සඳහා ඉදිරිපත් වන ඔබ මාර්ගගත (online) ක්‍රමයට පරිගණකානුසාරයෙන් එයට මුහුණ දිය යුතුය.</li>
              <li>✸ කඩදාසි , පෑන් , පැන්සල් වැනි උපකරණ රැගෙන යාම තහනම් වන අතර පරිගණකයේ මෞසය (mouse )භාවිතා කරමින් පිළිතුරු සැපයිය යුතුය.</li>
              <li>✸ ප්‍රශ්න පත්‍රය සවන්දීම (Listning) සහ කියවීම (Reading) යනුවෙන් කොටස් දෙකකි</li>
              <li>✸ එක් ප්‍රශ්න පත්‍රයකට ප්‍රශ්න 40 බැගින් ලැබෙන අතර කාලය මිනිත්තු 50ක් ලැබෙනු ඇත. ඒ අනුව ප්‍රශ්න පත්‍ර දෙක සඳහා ප්‍රශ්න 80ක් ලැබෙන අතර මුළු කාලය මිනිත්තු 100කි.</li>
              <li>✸ කියවීම ප්‍රශ්න පත්‍රයේ ඇති ප්‍රශ්න නැවත නැවත පරික්ෂා කර පිළිතුරු සැපයිය හැකි නමුත් සවන්දීම ප්‍රශ්න පත්‍රයේ එසේ කළ නොහැක.</li>
              <li>✸ සවන්දීම පත්‍රයේ සෑම ප්‍රශ්නයක් ම දෙවරක් ඉදිරිපත් කරන අතර හොඳින් සවන් දී නිවැරදි පිළිතුර සැපයිය යුතුය.</li>
            </ul>

            <div className="eps-info-box">
              එමෙන් ම කොරියානු භාෂා ප්‍රවීණතා පරීක්ෂණය සඳහා සුදුසුකම් ලැබූ ඔබ ඉදිරි සියළු තොරතුරු ලබා ගැනීම සඳහා ශ්‍රී ලංකා විදේශ සේවා නියුක්ති කාර්යාංශයේ උපදෙස් පරිදි ඔබේ නමින් EPS ගිණුමක් විවෘත කළ යුතු වේ. ඒ සඳහා වැඩිදුර තොරතුරු www.eps.co.kr යන වෙබ් අඩවියෙන් හෝ www.slbfe.lk යන වෙබ් අඩවියෙන් ඔබට ලබා ගත හැකිය.
            </div>
          </div>
        </ScrollReveal>

        {/* CTA Button */}
        <div className="bgk-footer-cta">
          <button className="cta-button">ලියාපදිංචි වන්න</button>
        </div>
      </div>
    </div>
  );
}
